module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAKlBMVEUuMDArLS0sLi4rLS0uMDAsLi4uMDAuMDAuMDAuMDAuMDAAAAAtLy8uMDA4BSQIAAAADHRSTlNt9MXzbsMTSASRKAC6IOQMAAAAaElEQVR42u3Syw6AIAxE0SqPlkr//3c1CjE0gbKThXd9VpOBY6pVGOIMI+dogoGIt1nMIjmaLMlVshjLHRssPCyMGUoJR4y2yhwNmK9KjwJqjJIeBdQYb6nHWJq4w/aWhQVv+bOffc1O/6A+OFn5rTQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_asc@2x.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_asc@2x.png
// module chunks = 2